<template>
  <div class="relative">
    <div class="text-sm text-text transition duration-200 flex group cursor-pointer"
         @click="popupOpen = !popupOpen">
      <IconMoreSettings class="text-icon mr-4 group-hover:text-icon-hover transition duration-200"/>
      {{ $t('accountsSettings') }}
    </div>
    <div v-if="popupOpen" class="settings-popup"
         v-on-click-away="hidePopup">
      <div class="text-xl font-bold text-text leading-tight mb-8">{{ $t('accountsSettings') }}</div>
      <div class="text-text-label text-xs mb-4 -mt-0-5">{{ $t('setAccSortLabel') }}</div>
      <BaseRadioGroup :value="current_space.data.account_sort_type"
                      :options="acc_sort_list"
                      @change="saveSettings({account_sort_type:$event})"/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import BaseRadio from "@/components/UI/BaseRadio";
import RadioGroup from '@/components/UI/RadioGroup.vue';
import BaseRadioGroup from "@/components/UI/BaseRadioGroup";
import IconMoreSettings from "@/components/icons/IconMoreSettings";
import {directive as onClickAway} from "vue-clickaway";

export default {
  name: "AccountsSpaceSettings",
  components: {
    IconMoreSettings,
    BaseRadioGroup,
    BaseRadio,
    RadioGroup,
  },
  directives: {
    onClickAway: onClickAway
  },
  data() {
    return {
      popupOpen: false,
    }
  },
  computed: {
    ...mapState('space', ['current_space']),
    acc_sort_list() {
      return [
        {value: 1, label: this.$t('setAccSortManual')},
        {value: 2, label: this.$t('setAccSortDefault')}
      ]
    },
  },
  methods: {
    ...mapActions('space', ['updateSpace']),
    ...mapMutations('space', ['setCurrentSpaceInfo']),
    hidePopup() {
      this.popupOpen = false;
    },
    async saveSettings(payload) {
      try {
        const res = await this.updateSpace(payload)
        if (res.body.success) {
          this.setCurrentSpaceInfo(res.body.data);
        }
      } catch (e) {
        console.error(e)
      }
    },
  },
  i18n: {
    messages: {
      en: {
        accountsSettings: 'Accounts settings',
        setAccSortLabel: 'In what order should you display your invoices?',
        setAccSortManual: 'I\'ll sort manually',
        setAccSortDefault: 'Sort by balance, highest to lowest',
      },
      ru: {
        accountsSettings: 'Настройки счетов',
        setAccSortLabel: 'В каком порядке показывать ваши счета?',
        setAccSortManual: 'Я отсортирую вручную',
        setAccSortDefault: 'Сортировать по балансу, от большего к меньшему',
      }
    }
  }
}
</script>

<style scoped lang="scss">
.settings-popup {
  @apply absolute -right-16 -bottom-5 z-110 transform translate-y-full
  bg-block shadow-popup p-12 rounded;
  width: 415px;

  &:before {
    content: '';
    @apply absolute bg-block;
    top: -3px;
    right: 24%;
    width: 7px;
    height: 7px;
    transform: rotate(-45deg);
    clip-path: polygon(0 0, 100% 0, 100% 100%);
  }
}
</style>
